import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { apiFindAllCollection, apiUpdateCollection } from "../api/collection";
import { generateQueryString } from "../helpers/functions/generateQueryString";
import {
  findAllCollection,
  setErrorCollection,
  setLoadingCollection,
  updateCollection,
} from "../redux/action/collection.action";
import { useState } from "react";
import { CollectionResponse } from "../types/collection.type";
import { ApplicationState } from "../redux/store";

export default function useCollection() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { latestParams } = useSelector(
    (state: ApplicationState) => state.configApp
  );

  const [collections, setCollections] = useState<CollectionResponse[]>([]);
  const [count, setCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchAllCollection = async (params: any) => {
    try {
      // dispatch(setLoadingCollection(true));
      setIsLoading(true);

      let query = generateQueryString(params);

      const result = await apiFindAllCollection(query);
      console.log(result);

      // dispatch(findAllCollection(result.data));

      // dispatch(setLoadingCollection(false));

      setCollections(result?.data?.payload?.results);
      setCount(result?.data?.payload?.count);
      setIsLoading(false);
    } catch (error: any) {
      // dispatch(setLoadingCollection(false));
      setIsLoading(false);
      dispatch(setErrorCollection(error.response));
    }
  };

  const updateCollectionApproval = async (params: any) => {
    try {
      // dispatch(setLoadingCollection(true));
      setIsLoading(true);

      const result = await apiUpdateCollection(params);
      console.log(result);

      if (result.data.payload) {
        const paramsString = latestParams.params;

        const queryObject = Object.fromEntries(
          new URLSearchParams(paramsString)
        );

        fetchAllCollection(queryObject);

        // dispatch(updateCollection(result.data.payload));
      } else {
        console.log("Something wrong");
      }

      // dispatch(setLoadingCollection(false));
      setIsLoading(false);
    } catch (error: any) {
      // dispatch(setLoadingCollection(false));
      setIsLoading(false);
      dispatch(setErrorCollection(error.response));
    }
  };

  return {
    fetchAllCollection,
    updateCollectionApproval,
    isLoading,
    count,
    collections,
  };
}
